
import React from 'react'
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';

const ReviewVoucher = ({ visible, hideModal }) => {
    return (
        <Modal
            isOpen={visible}
            toggle={hideModal}
            size="lg"
            style={{ maxWidth: '30%' }}
        >
            <ModalHeader toggle={hideModal}><h3>Vouchers</h3></ModalHeader>
            <ModalBody><div className=""><h5>You have 3rd party voucher which are awaiting your approval</h5></div></ModalBody>
            <ModalFooter>
                <Button onClick={hideModal}>
                    Cancel
                </Button>
                <Button color="primary" onClick={() => { window.location.href = "/app/pages/vouchers" }}>
                    Review
                </Button>
            </ModalFooter>
        </Modal >
    )
}
export default ReviewVoucher;